<form class= "criteria-form" #dealerCriteriaForm="ngForm">

  <div class="banner-section">
    <h3>Mes critères</h3>

    <div class="filter-button" >
      <mat-label>Filtres</mat-label>
      <button mat-button matTooltipPosition="above" matTooltip="Filtres" (click)="toggleShowCriteria()"> <mat-icon>tune</mat-icon></button>
    </div>

  </div>

  <div class="criterias-section" [style.display]="showCriteriaPanel ? 'block' : 'none'" (window:resize)="onResize($event)">
    <div class="criterias-fields">

      <!-- <mat-form-field >
      <mat-label>Vente/Location</mat-label>
      <mat-select name="businessLines" (selectionChange)="onBusinessLineChange()" [(value)]="selectedBusinessLine">
        <mat-option *ngFor="let line of businessLinesBD" [value]="line" >{{line}}</mat-option>
      </mat-select>
    </mat-form-field> -->

    <mat-form-field>
      <mat-label>Marque</mat-label>
      <mat-select name="makes"  [multiple]="false" (selectionChange)="onMakeChange($event)" [(ngModel)]="dealerCriteria.specialtyMakes[0]">
        @for (make of carMakesBD; track make; let i = $index) {
          <mat-option [value]="make" >{{make}}</mat-option>
        }
      </mat-select>
    </mat-form-field>


    <!-- <mat-form-field>
    <mat-label>Modèle</mat-label>
    <mat-select name="models"  [disabled]="carCriteria.makes.length===0" multiple (selectionChange)="onCriteriaChange()" [(ngModel)]="carCriteria.models">
      <mat-option *ngFor="let model of carModelsBD" [value]="model" >{{model}}</mat-option>
    </mat-select>
  </mat-form-field>  -->

  <mat-form-field>
    <mat-label>Service demandé</mat-label>
    <mat-select name="serviceProvided"  [multiple]="false" (selectionChange)="onServiceProvidedChange($event)" [(ngModel)]="dealerCriteria.servicesProvided[0]">
      @for (srv of seviceTypesBD; track srv; let i = $index) {
        <mat-option [value]="srv.code" >{{srv.title}}</mat-option>
      }
    </mat-select>
  </mat-form-field>

</div>

<!--
<div >
  <mat-form-field>
    <mat-label> Date création </mat-label>
    <mat-date-range-input matInput [rangePicker]="picker2" >
      <input  matStartDate placeholder="Début" name="start" (dateChange)="onSelectedDatesChange($event)" [(ngModel)]="dealerCriteria.minCreatedDate" >
      <input  matEndDate placeholder="Fin" name="end" (dateChange)="onSelectedDatesChange($event)" [(ngModel)]="dealerCriteria.maxCreatedDate" >
    </mat-date-range-input>
    <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
    <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
    <mat-date-range-picker #picker2></mat-date-range-picker>
  </mat-form-field>
</div> -->

<!-- <div>
<span class="slider">
  <mat-label>
    Année <br />
    <span class="info">
      (De {{carCriteria.yearMin}} à {{carCriteria.yearMax}})
    </span>
  </mat-label>

  <mat-slider [disabled]="disabled"
    [max]="yMax"
    [min]="yMin"
    [step]="1"
    [discrete]="thumbLabel"
    [showTickMarks]="showTicks"
    [displayWith]="formatSliderLabel"
    (slideend)="onCriteriaChange()"
    (pointerup)="onCriteriaChange()">

    <input matSliderStartThumb name="yearMin" [(ngModel)]="carCriteria.yearMin">
    <input  matSliderEndThumb name="yearMax" [(ngModel)]="carCriteria.yearMax">

  </mat-slider>
</span>

</div>

<div >
  <span class="slider">

    <mat-label>
      Prix <br />
      <span class="info">
        ({{formatSliderLabel (carCriteria.priceMin)}} FCFA - {{formatSliderLabel(carCriteria.priceMax)}} FCFA)
      </span>
    </mat-label>

    <mat-slider [disabled]="disabled"
      [max]="pMax"
      [min]="pMin"
      [step]="step"
      [discrete]="thumbLabel"
      [showTickMarks]="showTicks"
      [displayWith]="formatSliderLabel"
      (slideend)="onCriteriaChange()"
      (pointerup)="onCriteriaChange()">

      <input matSliderStartThumb name="priceMin" [(ngModel)]="carCriteria.priceMin">
      <input  matSliderEndThumb name="priceMax" [(ngModel)]="carCriteria.priceMax">

    </mat-slider>
  </span>
</div>
-->
<div class="criterias-fields">
  <mat-form-field >
    <mat-label> Pays</mat-label>
    <mat-select matInput id="country-select" multiple [(value)]="selectedCountryCodes" (selectionChange)="updateCountries($event)" >
      <mat-select-trigger class = "mini-flags">

        @for (code of selectedCountryCodes; track code; let i = $index) {
          <span class = "mini-flag">
            <img  mat-card-image src="assets/images/country-flags/{{code}}.png" alt="{{code}}">  &nbsp;
          </span>
        }

      </mat-select-trigger>

      @for (code of countryCodeOptions; track code; let i = $index) {
        <mat-option matOption class = "country-option" [value]="code" >
          <span class = "mini-flag">
            <img  mat-card-image src="assets/images/country-flags/{{code}}.png" alt="{{code}}">
          </span>
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <!-- Cities: <h6 *ngFor="let city of citiesBD"  >{{city}}</h6> -->
  <mat-form-field appearance ="outline" >
    <mat-label>Ville</mat-label>
    <mat-select name="cities"  [disabled]="selectedCountryCodes.length===0" multiple (selectionChange)="onCriteriaChange()" [(ngModel)]="dealerCriteria.cities">
      @for (city of citiesBD; track city) {
        <mat-option [value]="city" >{{city}}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <!--
  <mat-form-field>
    <mat-label>Boîte</mat-label>
    <mat-select name="gearboxes"  multiple (selectionChange)="onCriteriaChange()" [(ngModel)]="carCriteria.gearboxes">
      <mat-option *ngFor="let gb of gearboxesBD" [value]="gb" >{{gb}}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field >
    <mat-label>Carburant</mat-label>
    <mat-select name="fuelTypes"  multiple (selectionChange)="onCriteriaChange()" [(ngModel)]="carCriteria.fuelTypes">
      <mat-option *ngFor="let ft of fuelTypesBD" [value]="ft" >{{ft}}</mat-option>
    </mat-select>
  </mat-form-field>
  -->
</div>

</div>

@if (showCriteriaPanel) {
  <div class="submit-section" >
    <button type="submit" mat-button (click)="saveAlert()" class="cta-button-keep">
      <mat-icon>add_alert</mat-icon>
    </button>
    <!-- [disabled]="!dealerCriteriaForm.form.valid" -->
    <button type="submit" mat-button (click)="submitSearchForm()" class="cta-button-keep" >
      <mat-icon>directions_car</mat-icon>
      @if ((fetchingPreview$ | async)) {
        <span style="text-align:center">
          <mat-spinner  [diameter]="20"></mat-spinner>
        </span>
      }
      @if (!(fetchingPreview$ | async)) {
        <span>
          {{ (previewTotalCount$ | async) }} providers
        </span>
      }
    </button>
  </div>
}
@if (showCriteriaPanel) {
  <button type="submit" mat-button (click)="saveAlert()" class="simple-button-keep">
    <mat-icon>add_alert</mat-icon>
    <span>Enregistrer la recherche</span>
  </button>
}

@if (showCriteriaPanel) {
  <button type="submit" mat-button (click)="resetSearch()" class="simple-button-keep" >
    <mat-icon>autorenew</mat-icon>
    <span>
      Réinitialiser les filtres
    </span>
  </button>
}

</form>


